/** Centered dialogs sit on the window, so they must not stretch the map chrome. */
export function elementExtendsMapChrome(child: HTMLElement): boolean {
  if (child.dataset.slot === 'dialog-overlay') return false;
  if (
    child.dataset.slot === 'dialog-content' &&
    (child.dataset.position ?? 'default') === 'default'
  ) {
    return false;
  }
  return true;
}
